export const normalizeDashboardResponse = (data) => {
  const result =
    data?.result && typeof data.result === "object" ? data.result : {};

  return {
    reports: result,
    announcements: Array.isArray(result.announcements)
      ? result.announcements
      : [],
    next: result.next,
  };
};
